import type { FaireProductEntity } from "../../entity_types/product";

export const p_s6xyu7vcuj: FaireProductEntity = {
  token: "p_s6xyu7vcuj",
  type: "product",
  name: "Beaded Necklace- in blue with 14k gold accents",
  brandToken: "b_d9me6u99",
  brandName: "Freestone",
  imageUrl: "https://cdn.faire.com/fastly/e659bb8b3bec148d4e3970981222ee24145c84f8a246b8c632a9ee9c1a78a6e7.jpeg",
  galleryImageUrls: [],
  priceDollars: 34,
  description: "• 14k gold-filled beads and findings\n• glass seed beads\n• adjustable 16-18 inches or 18-20 inches",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:53.536Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
